import React, { useState, useEffect } from "react";

export default function CommentPolicy() {
    return <>
        <div className="p-4 bg-white rounded-lg shadow-md">
            <h1 className="mb-4 text-2xl font-semibold">OSIS Smandapura Comment Policy</h1>
            <p className="mb-2 text-gray-700">Welcome to our community! We value open discussions and diverse perspectives. To ensure a positive experience for everyone, we kindly ask all participants to adhere to the following guidelines:</p>
            <ul className="mb-4 list-disc list-inside text-gray-700">
                <li><b>Be Respectful:</b> Treat others with kindness and respect. Avoid personal attacks, offensive language, or disrespectful behavior.</li>
                <li><b>Stay on Topic:</b> Keep your comments relevant to the discussion or subject matter of the post.</li>
                <li><b>Use Appropriate Language:</b> Refrain from using vulgar, discriminatory, or abusive language.</li>
                <li><b>No Spam or Self-Promotion:</b> Do not post spam, advertisements, or irrelevant links.</li>
                <li><b>Respect Privacy:</b> Avoid sharing personal information about yourself or others.</li>
                <li><b>Constructive Criticism:</b> Feel free to share your opinions but ensure your feedback is constructive and adds value to the discussion.</li>
        </ul>
            <p className="text-gray-700">
                We reserve the right to remove comments that violate these guidelines. Repeated violations may result in banning from the platform.
            </p>
            <p className="mt-2 text-gray-700">
                Thank you for contributing to a respectful and engaging community! 😊
            </p>
        </div>

    </>
}
